<template>
  <common-layout-template :bg_ground_gray="true" :isBread="true" :breadHeading="'お問い合わせ'">
    <template v-slot:body>
      <contact-form
        v-if="isPage==='form' && isReady"
        :isPage="isPage"
        :userData="userData"
        :requestBody="requestBody"
        @input="isPage = $event"
      />
      <contact-confirm
        v-if="isPage==='conf' && isReady"
        :isPage="isPage"
        :requestBody="requestBody"
        @input="isPage = $event"
      />
      <contact-complete v-if="isPage==='comp'" :isPage="isPage" />
    </template>
  </common-layout-template>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import MixinMeta from '@/plugins/mixin-meta';

import CommonFooter from '@/components/parts/CommonFooter';
import ContactForm from '@/components/contact/ContactForm';
import ContactConfirm from '@/components/contact/ContactConfirm';
import ContactComplete from '@/components/contact/ContactComplete';
import CommonLayoutTemplate from '@/components/templates/CommonLayoutTemplate';

const canonical = location.href.match(/\/$/) === null ? `${location.href}/` : location.href;

export default {
  name: 'Contact',
  components: {
    CommonFooter,
    ContactForm,
    ContactConfirm,
    ContactComplete,
    CommonLayoutTemplate,
  },
  mixins: [IsMobileMixin, MixinMeta],
  data() {
    return {
      isPage: 'form',
      isReady: false,
      err: {
        isErr: false,
        msg: '',
      },
      query: {
        ispage: null,
      },
      userData: {},
      requestBody: {
        name: '',
        kana: '',
        email: '',
        message: '',
      },
    };
  },
  metaInfo() {
    return {
      link: [
        { rel: 'canonical', href: canonical },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
  },
  async created() {
    this.metaSetForDefault('contact');
    if (this.isLoggedIn) await this.getUserData();

    const querystring = window.location.search;
    this.query = [...new URLSearchParams(querystring).entries()]
      .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
    if (this.query.ispage !== undefined) this.isPage = this.query.ispage;
    else this.isPage = 'form';

    this.isReady = true;
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  methods: {
    async getUserData() {
      this.err.isErr = false;
      this.err.msg = '';
      try {
        const userData = this.$store.state.user;
        this.userData = {
          sei: userData.user_metadata.family_name,
          mei: userData.user_metadata.given_name,
          seikana: userData.user_metadata.phonetic_family_name,
          meikana: userData.user_metadata.phonetic_given_name,
          email: userData.email,
        };
      } catch (e) {
        this.err.isErr = true;
        this.err.msg = 'ユーザー情報取得にエラーが発生しました。';
      }
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

  .forDev {
    position:fixed;
    top:0;
    right:0;
    z-index:1000;

    button {
      display: block;
    }
  }

</style>
